import {
  useCrarGachapon,
  useListarGachapon,
  useListarObjetos,
  useListarGrados,
  useListarPokemones,
  useEditarPokemonesGacha,
  useListarPokemonesGachaponTier,
  useSelectPokemon,
} from "../../../../Hooks/Admin";
import { useEliminarGachapon } from "../queries";
import { CustomTable } from "../../../../Components/Admin/CustomTable";
import { camposFormulario, formatData, camposFilter } from "./camposFormulario";
import { useEffect, useState } from "react";
import { Button, Modal } from "antd";
import { CustomForm } from "../../../../Components/Admin/CustomForm";
import { useSelectLogro } from "../../../../Hooks/Admin";

export const Gacha = () => {
  const [campos, setCampos] = useState();
  const queryListarObjetos = useListarObjetos([]);
  const queryListarGrados = useListarGrados([]);
  const eliminarGachaponMutation = useEliminarGachapon();
  
  // Query para listar gachapones con acceso a refetch
  const queryListarGachapon = useListarGachapon();

  const listarPokemonGacha = useListarPokemonesGachaponTier();
  const queryListarPokemon = useListarPokemones([]);
  const querySelectPokemon = useSelectPokemon();
  const querySelectLogro = useSelectLogro();

  const [pokemonesComunes, setPokemonesComunes] = useState([]);
  const [pokemonesTier, setPokemonesTier] = useState([]);
  const [loadingPokemones, setLoadingPokemones] = useState(false);

  useEffect(() => {
    if (queryListarPokemon.isSuccess && queryListarPokemon.isSuccess) {
      setCampos(
        camposFormulario({
          pokemones: queryListarPokemon.data,
          logros: querySelectLogro.data,
        })
      );

      setPokemonesComunes(queryListarPokemon.data);
    }
  }, [queryListarPokemon.isSuccess]);

  const [modalPokemones, setModalPokemones] = useState(null);

  // Llama a la API cuando se abre el modal de pokemones
  const handleOpenPokemones = async (row) => {
    setModalPokemones(row);
    setLoadingPokemones(true);
    try {
      const data = await listarPokemonGacha.mutateAsync(row.idGachapon);
      setPokemonesTier(data);
    } finally {
      setLoadingPokemones(false);
    }
  };
  
  const columns = [
    {
      title: "Codigo",
      dataIndex: "codigo",
      width: "20%",
    },
    {
      title: "Nombre",
      dataIndex: "titulo",
      width: "20%",
    },
    {
      title: "Fecha Creación",
      dataIndex: "fechaCreacion",
      width: "20%",
    },

    {
      title: "Tier",
      dataIndex: "tier",
      width: "20%",
    },

    {
      title: "Pokemones",
      dataIndex: "tier",
      width: "20%",
      render: (e, row) => {
        return <Button onClick={() => handleOpenPokemones(row)}>Lista</Button>;
      },
    },
  ];

  // Helper para obtener los ids seleccionados por tier
  const getSelectedIdsByTier = (tier) => {
    return pokemonesTier
      .filter((p) => p.tier === tier)
      .map((p) => p.idPokemon);
  };

  // Opciones para los selects
  const opcionesPokemones = Array.isArray(querySelectPokemon?.data) ? querySelectPokemon.data : [];

  // Obtiene los seleccionados por defecto para cada tier
  const defaultComunes = getSelectedIdsByTier(1);
  const defaultRaros = getSelectedIdsByTier(2);
  const defaultEpicos = getSelectedIdsByTier(3);
  const defaultLegendarios = getSelectedIdsByTier(4);

  // Estado para picks por tier (controlado dinámicamente)
  const [seleccionados, setSeleccionados] = useState({
    comunes: [],
    raros: [],
    epicos: [],
    legendarios: [],
  });

  // Sincroniza picks al abrir modal o cambiar pokemonesTier
  useEffect(() => {
    setSeleccionados({
      comunes: getSelectedIdsByTier(1),
      raros: getSelectedIdsByTier(2),
      epicos: getSelectedIdsByTier(3),
      legendarios: getSelectedIdsByTier(4),
    });
  }, [modalPokemones, pokemonesTier]);

  // Handler para cambios en selects
  const handleChangeTier = (tierName, values) => {
    setSeleccionados((prev) => {
      // Elimina el/los pokemones seleccionados de los otros tiers
      const otrosTiers = ["comunes", "raros", "epicos", "legendarios"].filter((t) => t !== tierName);
      let nuevos = { ...prev, [tierName]: values };
      // Quita de los otros tiers los pokemones que ahora están en este tier
      otrosTiers.forEach((t) => {
        nuevos[t] = nuevos[t].filter((id) => !values.includes(id));
      });
      return nuevos;
    });
  };

  // Opciones filtradas para cada tier (en tiempo real)
  const opcionesFiltradas = {
    comunes: opcionesPokemones.filter(
      (p) =>
        !seleccionados.raros.includes(p.value) &&
        !seleccionados.epicos.includes(p.value) &&
        !seleccionados.legendarios.includes(p.value)
    ),
    raros: opcionesPokemones.filter(
      (p) =>
        !seleccionados.comunes.includes(p.value) &&
        !seleccionados.epicos.includes(p.value) &&
        !seleccionados.legendarios.includes(p.value)
    ),
    epicos: opcionesPokemones.filter(
      (p) =>
        !seleccionados.comunes.includes(p.value) &&
        !seleccionados.raros.includes(p.value) &&
        !seleccionados.legendarios.includes(p.value)
    ),
    legendarios: opcionesPokemones.filter(
      (p) =>
        !seleccionados.comunes.includes(p.value) &&
        !seleccionados.raros.includes(p.value) &&
        !seleccionados.epicos.includes(p.value)
    ),
  };

  const listaPokemones = {
    title: "Pokemones",
    campos: [
      {
        name: "idGacha",
        label: "id",
        type: "number",
        hidden: true,
        defaultValue: modalPokemones?.idGachapon ?? null,
      },
      {
        name: "comunes",
        label: "Pókemones Comunes",
        type: "multiple",
        opciones: opcionesFiltradas.comunes,
        defaultValue: seleccionados.comunes,
        value: seleccionados.comunes,
        onChange: (values) => handleChangeTier("comunes", values),
      },
      {
        name: "raros",
        label: "Pókemones Raros",
        type: "multiple",
        opciones: opcionesFiltradas.raros,
        defaultValue: seleccionados.raros,
        value: seleccionados.raros,
        onChange: (values) => handleChangeTier("raros", values),
      },
      {
        name: "epicos",
        label: "Pókemones Epicos",
        type: "multiple",
        opciones: opcionesFiltradas.epicos,
        defaultValue: seleccionados.epicos,
        value: seleccionados.epicos,
        onChange: (values) => handleChangeTier("epicos", values),
      },
      {
        name: "legendarios",
        label: "Pókemones Legendarios",
        type: "multiple",
        opciones: opcionesFiltradas.legendarios,
        defaultValue: seleccionados.legendarios,
        value: seleccionados.legendarios,
        onChange: (values) => handleChangeTier("legendarios", values),
      },
    ],
  };

 

  // Inicializa gachaData solo una vez con los datos de la query
   // Eliminar con confirmación modal
  const onDelete = (row) => {
    Modal.confirm({
      title: '¿Está seguro que desea eliminar este gachapon?',
      content: `Se eliminará permanentemente el gachapon "${row.titulo}" con código "${row.codigo}".`,
      okText: 'Sí, eliminar',
      okType: 'danger',
      cancelText: 'Cancelar',
      onOk: async () => {
        try {
          await eliminarGachaponMutation.mutateAsync({
            idGachapon: row.idGachapon
          });
          // Refresca la tabla después de eliminar exitosamente
          queryListarGachapon.refetch();
        } catch (error) {
          // Los errores ya son manejados por el hook
        }
      },
    });
  };

  return (
    <>      {campos && (
        <CustomTable
          tituloTabla="Gachapones"
          camposFilter={camposFilter}
          camposFormularioModal={campos}
          queryListarOut={queryListarGachapon}
          formatData={formatData}
          columns={columns}
          camposAgregar={camposFormulario({logros: querySelectLogro.data,})}
          queryCrear={useCrarGachapon}
          imagen={true}
          onDelete={onDelete}
          editable={true} // Habilita la edición
          queryEditar={useEditarPokemonesGacha} // Usa el hook de edición
        />
      )}
      <Modal
        title={`Lista pokemones`}
        open={modalPokemones ? true : false}
        footer={null}
        onCancel={() => {
          setModalPokemones(null);
          setPokemonesTier([]);
        }}
        cancelText="Cancelar"
      >
        {loadingPokemones ? (
          <div>Cargando...</div>
        ) : (
          <CustomForm
            name={"agregar-pokemones"}
            camposFormulario={listaPokemones}
            querySubmit={useEditarPokemonesGacha}
            pokemonesTier={pokemonesTier}
            setOpenModal={setModalPokemones}
            values={seleccionados}
            key={JSON.stringify(seleccionados)}
          />
        )}
      </Modal>
    </>
  );
};
